/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export type ObjectMap = {
	key: string;
	name: string;
};

export const TECHNOLOGIES = [
	{
		key: 'js',
		name: 'Vanilla JS'
	},
	{
		key: 'react',
		name: 'React'
	},
	{
		key: 'vue',
		name: 'Vue'
	},
	{
		key: 'angular',
		name: 'Angular'
	}
] as const satisfies ReadonlyArray<ObjectMap>;

export const INSTALL_METHODS = [
	{
		key: 'cdn',
		name: 'Cloud (CDN)'
	},
	{
		key: 'npm',
		name: 'Self-hosted (npm)'
	},
	{
		key: 'zip',
		name: 'Self-hosted (ZIP)'
	}
] as const satisfies ReadonlyArray<ObjectMap>;

export const CODE_OUTPUT_OPTIONS = [
	{
		key: 'download',
		name: 'Download project'
	},
	{
		key: 'snippets',
		name: 'Copy code snippets'
	},
	{
		key: 'stackblitz',
		name: 'Edit in StackBlitz'
	}
] as const satisfies ReadonlyArray<ObjectMap>;

export type Technology = typeof TECHNOLOGIES[ number ][ 'key' ] | null;

export type InstallMethod = typeof INSTALL_METHODS[ number ][ 'key' ] | null;

export type CodeOutput = typeof CODE_OUTPUT_OPTIONS[ number ][ 'key' ] | null;
